/* ============================================================
   Mobile sliders — at ≤768px, convert these grids into horizontal
   swipe sliders with dot indicators. Ported from the reference
   moon-rise-framer/script.js lines 470-568.

   Grids handled:
     .section-products .products-grid     (.product-card)
     .store-services-grid                 (.store-service-card)
     .instagram-grid                      (.instagram-item)
   Note: .reviews-grid is excluded — testimonials has its own
   .reviews-mobile-dots scroll-snap system.
   ============================================================ */

(function () {
  'use strict';

  function init() {
    var sliderConfigs = [
      { grid: '.section-products .products-grid', child: '.product-card' },
      { grid: '.store-services-grid',             child: '.store-service-card' },
      { grid: '.instagram-grid',                  child: '.instagram-item' }
    ];

    function setup() {
      var isMobile = window.innerWidth <= 768;

      sliderConfigs.forEach(function (cfg) {
        var grids = document.querySelectorAll(cfg.grid);
        grids.forEach(function (grid) {
          var children = grid.querySelectorAll(cfg.child);
          if (children.length < 2) return;

          var dotsId = grid._dotsId || ('mrDots-' + Math.random().toString(36).slice(2, 9));
          grid._dotsId = dotsId;
          var existingDots = document.getElementById(dotsId);

          if (isMobile) {
            grid.classList.add('mobile-slider');

            if (!existingDots) {
              var dotsWrap = document.createElement('div');
              dotsWrap.className = 'slider-dots';
              dotsWrap.id = dotsId;

              children.forEach(function (_, i) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'slider-dot' + (i === 0 ? ' is-active' : '');
                dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
                dot.addEventListener('click', function () {
                  children[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                });
                dotsWrap.appendChild(dot);
              });

              grid.parentNode.insertBefore(dotsWrap, grid.nextSibling);
            }

            if (!grid._sliderBound) {
              grid._sliderBound = true;
              grid.addEventListener('scroll', function () {
                updateDots(grid, dotsId, children);
              }, { passive: true });
            }
          } else {
            grid.classList.remove('mobile-slider');
            if (existingDots) existingDots.remove();
            grid._sliderBound = false;
          }
        });
      });
    }

    function updateDots(grid, dotsId, children) {
      var dotsWrap = document.getElementById(dotsId);
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.slider-dot');
      var gridLeft = grid.getBoundingClientRect().left;

      var closestIdx = 0;
      var closestDist = Infinity;

      children.forEach(function (child, i) {
        var dist = Math.abs(child.getBoundingClientRect().left - gridLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === closestIdx);
      });
    }

    setup();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 200);
    });

    // Re-run when sections reload in the Shopify theme editor
    document.addEventListener('shopify:section:load', setup);
    document.addEventListener('shopify:section:unload', setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
